// extracted by css-extract-rspack-plugin
export default {"cls1":"search_work_card_redesign-cls1_a97","cls2":"search_work_card_redesign-cls2_cXm search_work_card_redesign-cls1_a97"};